import { defineActions } from '@noven-prime/lattice-core';
import { enhanceWithClaude } from './service.js';
/**
 * AI Assist capability actions — admin only for now.
 */
export const aiAssistActions = defineActions({
    enhanceText: {
        id: 'enhanceText',
        name: 'Enhance Text',
        description: 'Improve a piece of site copy with the configured Claude model',
        params: {
            type: 'object',
            properties: {
                text: { type: 'string', description: 'The text to enhance' },
                context: {
                    type: 'string',
                    description: 'What the text is, e.g. "a service card description"',
                },
            },
            required: ['text'],
        },
        result: { type: 'object' },
        access: {
            scopes: ['root', 'admin'],
        },
        execute: async (params, _context) => {
            return enhanceWithClaude(params.text, params.context);
        },
    },
});
//# sourceMappingURL=actions.js.map